import getSelectedFolderId from 'owa-mail-store/lib/utils/getSelectedFolderId';
import initializeGuidsForSearchStore from '../actions/initializeGuidsForSearchStore';
import setStaticFolderScopeId from '../actions/setStaticFolderScopeId';
import startSearchSession from '../actions/startSearchSession';
import startSearchSessionService from '../services/startSearchSessionService';
import { getStore as getSearchStore } from 'mini-mail-search-store/lib/store/Store';
import { orchestrator } from 'satcheljs';

export default orchestrator(
    startSearchSession,
    async ({ onCompletion }: { onCompletion?: () => any }) => {
        const searchStore = getSearchStore();
        if (searchStore.searchSessionGuid) {
            onCompletion && onCompletion();
            return;
        }
        if (!searchStore.staticFolderScopeId) {
            // As there is no folderId selected,
            // we should go with "all folder" by passing isAllFolder as true
            setStaticFolderScopeId(
                getSelectedFolderId() || searchStore.previouslySelectedFolderId,
                true // is all folder scope
            );
        }
        initializeGuidsForSearchStore();

        const finalStaticFolderScopeId =
            searchStore.staticFolderScopeId || searchStore.previouslySelectedFolderId;
        startSearchSessionService(searchStore.searchSessionGuid, finalStaticFolderScopeId);
        onCompletion && onCompletion();
    }
);
